export default "/_next/static/images/bb558de23afd2fab51ee9d978f627808.png";